import { render } from "./GameTwoViewCard.vue?vue&type=template&id=a5a48e6c"
import script from "./GameTwoViewCard.vue?vue&type=script&lang=js"
export * from "./GameTwoViewCard.vue?vue&type=script&lang=js"

import "./GameTwoViewCard.vue?vue&type=style&index=0&id=a5a48e6c&lang=css"

import exportComponent from "C:\\src\\Inmersys\\tres-prima\\mundo-zac-webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__